export default __webpack_public_path__ + "static/media/client.3188340a.svg";